export default "__VITE_ASSET__CSYc21x5__"